import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import {
  IApiResponse,
  IEventDto,
  IFilterPaginationDto,
} from '../models';

@Injectable()
export class EventService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getEventList(model: IFilterPaginationDto): Observable<IEventDto[]> {
    return this.post(`admin/event/list`, model);
  }

  public changeEventStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/event/${id}`, null);
  }

  public addEvent(model: IEventDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/event/save`, model);
  }

}
